module.exports = __webpack_public_path__ + "files/a155c70da1816fc41839d58ca3b945ef.png";